// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7892) return "static/chunks/7892-67fcd35bd0ec337a.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"85465245d0eeab0a","6329":"871b5cac3fac08f8","9872":"44c5f4a10304d41d"}[chunkId] + ".js";
};